/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './rating.scss';
import PageHeader from '../../layouts/page-header/PageHeader';
import DownloadButton from './button';
import { useDispatch } from 'react-redux';
import { getRatings } from '../../store/actions';
import { base } from '../../store/api';
import Loading from '../../component/Loading';

const Rating = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [ratings, setRatings] = useState([]);

  useEffect(() => {
    const lang = language === 'tm' ? 'tk' : language;
    setLoading(true);
    getRatings(dispatch, {}, lang, (err, res) => {
      if (err) console.log(err);
      setRatings(res?.results || []);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, currentPage]);

  const handleClick = (src) => {
    const cleanUrl = src.split("?")[0].split("#")[0];
    const extension = cleanUrl.split(".").pop() || "bin";

    const link = document.createElement("a");
    link.href = src;
    link.download = `document.${extension}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <div className="site-content">
        <PageHeader
          colSize="col-md-10"
          title={t('rating')}
          PagaHeaderBg={'/images/bg.svg'}
          breadCrumbItems={[{ label: t('home'), path: '/' }]}
        />
        <div className="event-ara page-template content-wrapper">
          <div className="container">
            <div className="row">
              {loading ? (
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '50px 0',
                  }}
                >
                  <Loading style={{ width: '10%' }} />
                </div>
              ) : (
                <div className="col-sm-12">
                  <div className="grid-wrapper grid-lg-2 grid-md-1">
                    {ratings.map((item) => (
                      <div
                        key={item.id}
                        className="tw-flex tw-flex-row tw-items-center tw-shadow tw-border tw-p-2.5 tw-gap-2"
                      >
                        <div className="tw-flex-grow tw-flex tw-flex-row tw-items-center tw-gap-x-4">
                          {item?.logo && (
                            <div className="tw-w-20 tw-shrink">
                              <img
                                src={base + item.logo}
                                alt="Logo"
                                width={80}
                                height={80}
                                className="tw-max-w-none tw-size-20 tw-object-contain"
                              />

                            </div>
                          )}
                          <Link
                            to={item.src ? base + item.src : null}
                            target="_blank"
                          >
                            <div
                              className="tw-text-base tw-md:tw-text-lg tw-text-black tw-font-bold">
                              {item.title}
                            </div>
                          </Link>
                        </div>
                        <div
                          className="tw-cursor-pointer"
                          onClick={() =>
                            handleClick(item.src ? base + item.src : null)
                          }
                        >
                          <DownloadButton />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Rating;
